var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"t__button",class:[
  't__button--'+_vm.type,
  {'is-plain': _vm.plain, 'is-disabled': _vm.disabled, 'is-round': _vm.round},
  't__button--size-'+_vm.size
  ],style:({width: _vm.width ? _vm.width + 'px' : 'auto'}),attrs:{"disabled":_vm.disabled},on:{"click":function($event){_vm.$emit('click')}}},[(_vm.icon !== '')?_c('i',{class:_vm.icon}):_vm._e(),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1804df8c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./packages/button/src/button.vue
// module id = kbV4
// module chunks = 2